// extracted by mini-css-extract-plugin
export default {"addActivity":"home_addActivity__8x6J7","navContainer":"home_navContainer__E2dhb"};